import { Navigate } from 'react-router-dom'
import { useProjectId } from '../../../hooks/useProjectId'
import { HasEarlierWavesProvider } from '../../../modules/Questionnaire/Kpi/HasEarlierWavesContext'
import { ConfirmPage } from '../MultiMarket/ConfirmPage'
import { WaveFlowBreadcrumb } from './WaveFlowBreadcrumb'
import { useWaveId } from './useWaveId'
import { useWaves } from './useWaves'

/**
 * The multi-market Confirm step scoped to this wave's markets. The waves are
 * refetched after a market changes, so the wave's status (and with it the lock
 * on its Survey step and the next wave's creation) follows the launch.
 */
export const WaveConfirmPage = () => {
  const projectId = useProjectId()
  const waveId = useWaveId()
  const { waves, loading, refetch } = useWaves(projectId)
  const wave = waves.find((candidate) => candidate.waveId === waveId)

  if (loading) {
    return null
  }

  if (!wave) {
    return <Navigate to={`/project/${projectId}`} replace />
  }

  const hasEarlierWaves = waves.some(
    (candidate) => candidate.number < wave.number
  )

  return (
    <HasEarlierWavesProvider value={hasEarlierWaves}>
      <ConfirmPage
        breadcrumb={<WaveFlowBreadcrumb activeStep="Confirm" />}
        markets={wave.surveys}
        onMarketsChanged={refetch}
      />
    </HasEarlierWavesProvider>
  )
}
